import { InMemoryCache } from "@apollo/client";
import generated from "@/gql/possible-types";

export function createCache(): InMemoryCache {
  return new InMemoryCache({ possibleTypes: generated.possibleTypes });
}
